__webpack_require__.p = "/ethnopedia/";